module.exports = __webpack_public_path__ + "static/media/myplaces.7d23b378.jpg";